import React from 'react'
import './section6.css'

import Repeatedsection from '../Repeatedsection/Repeatedsection'
const Section6 = () => {
    return (
        <>
            <Repeatedsection title='Electronic'/>
        </>
    )
}

export default Section6
